import { useEffect, useRef, useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';

interface GoogleLoginButtonProps {
	onSuccess: (response: any) => void;
	onError: () => void;
}

const MAX_WIDTH = 420;

export function GoogleLoginButton({ onSuccess, onError }: GoogleLoginButtonProps) {
	const containerRef = useRef<HTMLDivElement>(null);
	const [buttonWidth, setButtonWidth] = useState(MAX_WIDTH);

	useEffect(() => {
		const el = containerRef.current;
		if (!el) return;

		const observer = new ResizeObserver(([entry]) => {
			const width = Math.floor(entry.contentRect.width);
			setButtonWidth(Math.min(width, MAX_WIDTH));
		});

		observer.observe(el);
		return () => observer.disconnect();
	}, []);

	return (
		<div ref={containerRef} className="w-full" style={{ maxWidth: MAX_WIDTH }}>
			<GoogleLogin
				onSuccess={onSuccess}
				onError={onError}
				type="standard"
				theme="outline"
				size="large"
				shape="pill"
				logo_alignment="center"
				ux_mode="popup"
				useOneTap={false}
				width={buttonWidth}
			/>
		</div>
	);
}
